import Vue from 'vue';
import Vuetify from 'vuetify/lib';
// import minifyTheme from 'minify-css-string'
import colors from 'vuetify/lib/util/colors'
import light from './themes/light'
// import dark from './themes/dark'
import '@mdi/font/css/materialdesignicons.css'
import { de, en } from 'vuetify/lib/locale'

Vue.use(Vuetify);

const locale = localStorage.getItem('locale') || navigator.language.slice(0, 2) || 'de'

export default new Vuetify({
  lang: {
    locales: { de, en },
    current: locale
  },
  theme: { 
    themes: {
      light
    },
  },
});
